<h2>{{tableName}}</h2>
<aur-mat-table [tableData]="tableData"
               [tableConfig]="tableConfig">
</aur-mat-table>
